import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private _matIconRegistry = inject(MatIconRegistry);
  private _domSanitizer = inject(DomSanitizer);

  constructor() {
    this._matIconRegistry.addSvgIconSetInNamespace(
      'nx',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/symbol-defs.svg'
      )
    );
  }
}
